import e from "./highrise1841.mjs";
var h = "__lodash_hash_undefined__";
function s(t, a) {
  var _ = this.__data__;
  return this.size += this.has(t) ? 0 : 1, _[t] = e && a === void 0 ? h : a, this;
}
export {
  s as default
};
